import {createSelector} from '@reduxjs/toolkit'

import {includes} from '@shared/helpers/collection'
import {eq} from '@shared/helpers/lang'

import {FamilyPayStatement} from '@web/core/constants'
import {getFamilyPayStatement} from '@web/helpers/policies'
import {commonSelector} from '@web/slices/common/slice'
import {payMethodAvailableSelector} from '@web/slices/paymentMethod/slice'
import {familyPaySelector, familyPayMemberPaymentInfoSelector} from '@web/slices/payNext/slice'
import {membershipInfoSelector} from '@web/slices/purchaser/slice'

const payableStatements = [
    FamilyPayStatement.APPROVAL_PAYMENT,
    FamilyPayStatement.APPROVAL_PAYMENT_BY_PRE_APPROVAL_PAYMENT_DISABLED,
    FamilyPayStatement.PRE_APPROVAL_PAYMENT,
]

/**
 * 패밀리결제 결제수단 노출 방식을 결정하는 selector
 * see) https://oss.fin.navercorp.com/payment-fe/order-web/wiki/%ED%8C%A8%EB%B0%80%EB%A6%AC%ED%8E%98%EC%9D%B4-%EA%B2%B0%EC%A0%9C%EC%88%98%EB%8B%A8-%EB%85%B8%EC%B6%9C-%EC%A0%95%EC%B1%85
 */
export const familyPayStatementSelector = createSelector(
    membershipInfoSelector,
    payMethodAvailableSelector,
    familyPaySelector,
    familyPayMemberPaymentInfoSelector,
    commonSelector,
    (
        {subscribed: naverPlusMembershipSubscribed},
        {availablePayMethodTypes},
        {subscribed: familyPaySubscribed, role, status, invalidReason},
        memberPaymentInfo,
        {entry},
    ) => {
        const familyPayStatement = getFamilyPayStatement({
            memberPaymentInfo,
            role,
            entry,
            availablePayMethodTypes,
            naverPlusMembershipSubscribed,
            familyPaySubscribed,
            status,
            invalidReason,
        })

        const eqFamilyPayStatement = eq(familyPayStatement)

        return {
            familyPayStatement,
            isPayable: includes(familyPayStatement, payableStatements),
            isError: eqFamilyPayStatement(FamilyPayStatement.API_FAIL),
            isDisabled: eqFamilyPayStatement(FamilyPayStatement.DISABLE),
            isHidden: eqFamilyPayStatement(FamilyPayStatement.HIDE),
        }
    },
)
